import React from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { ordenarOpcionesPorLabel, textoMayusculas } from '../../utils/utils';

export const FILTRO_TODOS = 'todos';

export const CalendarioFiltros = ({
    filtros,
    opcionesProyecto = [],
    opcionesEstado = [],
    onChange,
    onReset,
}) => {
    const filtrosActivos = Object.values(filtros).filter((valor) => valor && valor !== FILTRO_TODOS).length;
    const proyectosOrdenados = ordenarOpcionesPorLabel(opcionesProyecto);
    const estadosOrdenados = ordenarOpcionesPorLabel(opcionesEstado);

    return (
        <Accordion
            disableGutters
            elevation={0}
            sx={{
                borderRadius: '20px',
                border: '1px solid rgba(229, 57, 53, 0.12)',
                boxShadow: '0 10px 24px rgba(68, 47, 44, 0.08)',
                backgroundColor: '#fff',
                overflow: 'hidden',
                '&::before': { display: 'none' },
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: 'var(--principal)' }} />}
                sx={{
                    px: { xs: 1.6, md: 2.2 },
                    py: 0.15,
                    minHeight: 58,
                    '& .MuiAccordionSummary-content': { my: 1 },
                }}
            >
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Box
                            sx={{
                                width: 34,
                                height: 34,
                                borderRadius: '10px',
                                display: 'grid',
                                placeItems: 'center',
                                backgroundColor: 'rgba(229, 57, 53, 0.12)',
                                color: 'var(--principal)',
                            }}
                        >
                            <FilterAltOutlinedIcon sx={{ fontSize: 18 }} />
                        </Box>

                        <Box>
                            <Typography sx={{ fontWeight: 700 }}>
                                Filtros del calendario
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                                Proyecto, estado y busqueda de tareas
                            </Typography>
                        </Box>
                    </Stack>

                    {filtrosActivos > 0 && (
                        <Chip
                            label={`${filtrosActivos} activos`}
                            size="small"
                            sx={{
                                borderRadius: '999px',
                                backgroundColor: 'rgba(229, 57, 53, 0.12)',
                                color: 'var(--principal)',
                                fontWeight: 700,
                            }}
                        />
                    )}
                </Stack>
            </AccordionSummary>

            <AccordionDetails
                sx={{
                    px: { xs: 1.6, md: 2.2 },
                    pt: 0.35,
                    pb: { xs: 1.5, md: 1.8 },
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1.2fr 1fr 1fr auto' },
                        gap: 1.2,
                        alignItems: 'end',
                    }}
                >
                    <TextField
                        label="Buscar"
                        size="small"
                        value={filtros.search}
                        onChange={(event) => onChange('search', event.target.value)}
                    />

                    <FormControl size="small" fullWidth>
                        <InputLabel>Proyecto</InputLabel>
                        <Select
                            value={filtros.proyecto}
                            label="Proyecto"
                            onChange={(event) => onChange('proyecto', event.target.value)}
                        >
                            <MenuItem value={FILTRO_TODOS}>Todos los proyectos</MenuItem>
                            {proyectosOrdenados.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {textoMayusculas(option.label)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl size="small" fullWidth>
                        <InputLabel>Estado</InputLabel>
                        <Select
                            value={filtros.estado}
                            label="Estado"
                            onChange={(event) => onChange('estado', event.target.value)}
                        >
                            <MenuItem value={FILTRO_TODOS}>Todos los estados</MenuItem>
                            {estadosOrdenados.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {textoMayusculas(option.label)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Button
                        onClick={onReset}
                        startIcon={<RestartAltIcon />}
                        variant="outlined"
                        sx={{ minHeight: 40, borderRadius: '12px', fontWeight: 700 }}
                    >
                        Limpiar
                    </Button>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};
